import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartColumn from '../../../components/charts/ChartColumn'
import ChartColumnSkeleton from '../../../components/skeletons/ChartColumnSkeleton'
import { ChartColumnThemes } from '../../../components/charts/types/ChartColumn'
import { ProductFiltersContext } from '../../../context/ProductFiltersContext'
import { ORDER_STATUS } from '../../../types/Order'
import { formatedProduct } from '../../../utils/Helpers'

const GET_ORDER_FINISHED = gql`
  query ordersAggs($filters: JSON) {
    ordersAggs(
      filters: $filters
      size: 0
      query: {
        bool: { filter: [{ term: { new_status: "${ORDER_STATUS.DELIVERED}" } }] }
      }
      aggs: {
        products: {
          nested: {
            path: "items"
          },
          aggs: {
            items: {
              terms: {
                field: "items.name.keyword",
                size: 10
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string;
  doc_count: number;
  totals: {
    value: number;
  };
}
const TopProductSales = (): JSX.Element => {
  const { filters } = useContext(ProductFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_ORDER_FINISHED,
    {
      notifyOnNetworkStatusChange: true
    }
  )
  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.ordersAggs.aggregations.products.items
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(formatedProduct(bucket.key))
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'top-product-sales'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      offsetY: -20,
      formatter: (val: number) => {
        return val
      },
      style: {
        colors: ['#304758']
      }
    },
    yaxis: {
      labels: {
        formatter: (value: number) => {
          return value
        }
      }
    }
  }
  const series = [
    {
      name: 'Quantidade',
      data: seriesData
    }
  ]

  if (!data) return <></>

  return (
    <Paper elevation={2}>
      <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>
        TOP 10 produtos mais vendidos (R$)
      </Typography>
      <ChartColumn
        options={options}
        series={series}
        theme={ChartColumnThemes.cleanGreen}
        height={320}
      />
    </Paper>
  )
}

export default TopProductSales
